import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

/**
 * @file 日期筛选项
 * @author alfielv
 * @modify fightingliu
 */
import _ from 'lodash';
import React, { useMemo, useCallback } from 'react';
import { DatePicker } from '@tencent/spaui'; // range最大跨度

var DATE_LONGEST_RANGE = 366;
export default (function (props) {
  var name = props.name,
      value = props.value,
      config = props.config,
      onChange = props.onChange,
      setActive = props.setActive;

  var _ref = config || {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'range' : _ref$type,
      onChangeFromConfig = _ref.onChange,
      onOpenFromConfig = _ref.onOpen,
      configProps = _objectWithoutProperties(_ref, ["type", "onChange", "onOpen"]);

  var startTimeKey = '';
  var endTimeKey = '';

  if (_.includes(name, ',')) {
    var nameArr = name.replace(/\s*/g, '').split(',');

    if (Array.isArray(nameArr) && _.size(nameArr) > 1) {
      startTimeKey = _.head(nameArr); // 传递给onRequest参数的起止日期

      endTimeKey = _.last(nameArr); // 传递给onRequest参数的截止日期
    }
  } // 日期值


  var dateValue = useMemo(function () {
    if (type === 'range') {
      var _ref2 = value || {},
          startDate = _ref2.start_time,
          endDate = _ref2.end_time;

      return {
        startDate: startDate,
        endDate: endDate
      };
    }

    return {
      date: value
    };
  }, [type, value]);
  var handleChange = useCallback(function (event, startDate, endDate) {
    var param = {
      start_time: startDate,
      end_time: endDate
    };

    if (startTimeKey && endTimeKey && type !== 'single') {
      var _$assign;

      param = _.assign(param, (_$assign = {}, _defineProperty(_$assign, startTimeKey, startDate), _defineProperty(_$assign, endTimeKey, endDate), _$assign));
    }

    var retData = type === 'range' ? param : startDate;
    onChangeFromConfig === null || onChangeFromConfig === void 0 ? void 0 : onChangeFromConfig(event, startDate, endDate);
    onChange === null || onChange === void 0 ? void 0 : onChange(retData);
  }, [type, startTimeKey, endTimeKey, onChangeFromConfig, onChange]);
  var handleOpen = useCallback(function (event, open) {
    onOpenFromConfig === null || onOpenFromConfig === void 0 ? void 0 : onOpenFromConfig(event, open);
    setActive === null || setActive === void 0 ? void 0 : setActive(open);
  }, [setActive, onOpenFromConfig]);
  return /*#__PURE__*/React.createElement(DatePicker, _extends({
    longestRange: DATE_LONGEST_RANGE
  }, configProps, {
    type: type
  }, dateValue, {
    onChange: handleChange,
    onOpen: handleOpen
  }));
});